module.exports = __webpack_public_path__ + "static/img/381_phase_function_Paper_PointsHejduk_Prediction.cf7a3fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/381_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 4CA0
// module chunks = 0